export const EXAM_PAPER_TYPE_READING_WRITING = "reading_writing";
export const EXAM_PAPER_TYPE_MATH = "math";
export const EXAM_PAPER_TYPE_ENGLISH = "english";
export const EXAM_PAPER_TYPE_READING = "reading";
export const EXAM_PAPER_TYPE_SCIENCE = "science";

export function getPaperTypeLabel(type: string) {
  if (type === EXAM_PAPER_TYPE_MATH) return "Math";
  if (type === EXAM_PAPER_TYPE_READING_WRITING) return "Reading and Writing";
  if (type === EXAM_PAPER_TYPE_ENGLISH) return "English";
  if (type === EXAM_PAPER_TYPE_READING) return "Reading";
  if (type === EXAM_PAPER_TYPE_SCIENCE) return "Science";

  // Default: replace underscores with spaces and capitalize first letter
  return type.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}
